import { render, staticRenderFns } from "./TurnoverPDF.vue?vue&type=template&id=452d11e1&"
import script from "./TurnoverPDF.vue?vue&type=script&lang=js&"
export * from "./TurnoverPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports